<section class="icon-attachment__section" [style.width.px]="width" [style.height.px]="height" (click)="onClicked()">
  <img [src]="iconUrl" />
</section>
